<template>
	<div class="hhdealers__form__wrap">
		<form role="filter" aria-label="" method="get" class="hhdealers__form" action="<?php echo esc_url( home_url( '/' ) ); ?>">

			<fieldset class="hhdealers__form__fieldset hhdealers__form__fieldset--brand">
				<legend>{{ getMicroCopy().map_copy_search_brands_title }}</legend>
				<div v-for="( brand, ind ) in uniqueBrands" :key="ind">
					<input 
						type="radio" 
						:id="brand.ID" 
						:name="brand.name" 
						:value="brand.slug" 
						v-model="currentFilter"
						@change="clearCheckboxes"
					>
					<label :for="brand.ID">{{ brand.name }}</label>
					<fieldset v-if="currentFilter === brand.slug && ( hasPro( brand.ID ) || hasProductGroups( brand.ID ) )" class="hhdealers__form__fieldset hhdealers__form__fieldset--subfilter">
						<legend class="screen-reader-text">{{ getMicroCopy().map_copy_search_label_subfilter }}</legend>
						<div v-if="hasPro( brand.ID )">
							<input 
								type="checkbox" 
								id="pro" 
								name="Subfilter" 
								value="pro" 
								v-model="subFilter"
							>
							<!-- $  { this.getSubFilter() ? 'PRO-' : '' } -->
							<label for="pro">{{ getMicroCopy().map_copy_search_label_pro }} <small><em v-html="createProDealersInfoLink( brand.infoPageUrl)"></em></small></label>
						</div>
						<div v-for="( group, index ) in brand.productGroepen" :key="index">
							<input 
								type="radio" 
								:id="group.ID" 
								name="Subfilter" 
								:value="[ group.slug ]" 
								v-model="productGroepen"
							>
							<label :for="group.ID">{{ getMicroCopy().map_copy_search_label_segments }} {{ group.name }}</label>
						</div>
					</fieldset>
				</div>
			</fieldset>

			<fieldset class="hhdealers__form__fieldset hhdealers__form__fieldset--location" :class="[ this.getActiveFilter() !== '' ? 'hhdealers__form__fieldset--location--is-enabled' : '' ]">
				<legend>{{ getMicroCopy().map_copy_search_location_title }}</legend>
				<div class="hhdealers__form__fieldset hhdealers__form__fieldset--location__inner">
					<button @click.prevent="handleLocationClick"><i aria-hidden="true" class="fa fa-crosshairs"></i></button>
					<label for="location-input">
						<span class="screen-reader-text">{{ getMicroCopy().map_copy_search_location_title }}</span>
						<input 
							type="text" 
							id="location-input" 
							placeholder="1000 Brussel" 
							value="" 
							name="Location"
							ref="locationInput"
							v-model="search"
							@keydown.enter.prevent="handleSearchSubmit"
							@place_changed="handleSearchSubmit"
						>
						<a href="" class="hhdealers__form__fieldset__clearbtn" @click.prevent="clearSearch()" :class="[ this.getSearch() !== '' ? 'hhdealers__form__fieldset__clearbtn--is-enabled' : '' ]"><i class="fa fa-times" aria-hidden="true"></i></a>
					</label>
					<button @click.prevent="handleSearchSubmit">{{ getMicroCopy().map_copy_search_location_label }}</button>
				</div>
			</fieldset>

		</form>
	</div>					
														
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import eventbus from '../utils/eventbus'
import { parseURL } from '../utils/urlparser'
export default {
	props: ['dealers'],
	data () {
		return {
			currentFilter: '',
			subFilter: '',
			productGroepen: [],
			search: '',
		}
	},
	/* eslint-disable no-unused-vars */
	created () {
		this.$watch( 'currentFilter', ( newValue, oldValue ) => {
			this.setActiveFilter( newValue )
		} ),
		this.$watch( 'subFilter', ( newValue, oldValue ) => {
			this.setSubFilter( newValue )
		} ),
		this.$watch( 'productGroepen', ( newValue, oldValue ) => {
			this.setProductGroepen( newValue )
		} )
	},
	mounted () {
		this.initializeFilters()
	},
	methods: {
		...mapActions([
			'setActiveFilter',
			'setSubFilter',
			'setProductGroepen',
			'setSearch',
			'setSearchCoords',
			'setReferrerProduct',
			'setReferrerProductID',
			'setUniqueBrands'
		]),
		...mapGetters([
			'getActiveFilter',
			'getSearch',
			'getMicroCopy'
		]),
		/* eslint-disable no-unused-vars */
		hasPro ( id ) {
			const results = this.dealers.filter( ( dealer ) => {
				return dealer.brands.find( ( brand ) => {
					return brand.ID === id && brand.pro === true
				} )
			})
			return results.length > 0 
		},
		hasProductGroups ( id ) {
			const results = this.dealers.filter( ( dealer ) => {
				return dealer.brands.find( ( brand ) => {
					return brand.ID === id && brand.productgroepen &&
						brand.productgroepen.length > 0
				} )
			} )
			return results.length > 0
		},
		clearCheckboxes () {
			this.setSubFilter( false )
			this.subFilter = false
			this.setProductGroepen( [] )
			this.productGroepen = []
			for ( const [ key, value ] of Object.entries( this.$refs ) ) {
				value.checked = false
			}
		},
		// handleSearch ( event ) {
		// 	// console.log( event )
		// 	this.search = event.target.value
		// 	this.setSearch( event.target.value )		
		// 	eventbus.$emit( 'search-launched', 'not geocoded' )
		// },
		handleSearchSubmit ( event ) {
			this.search = this.$refs.locationInput.value
			if ( this.search === '' ) {
				this.clearSearch()
			} else {
				this.setSearch( this.$refs.locationInput.value )
				eventbus.$emit( 'search-launched', 'not geocoded' )
			}
		},
		handleLocationClick () {
			if ( navigator.geolocation ) {
				navigator.geolocation.getCurrentPosition( (position, error) => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					}
					// console.log( 'filter', pos )
					this.setSearchCoords( pos )
					eventbus.$emit( 'search-launched', 'geocoded' )
					eventbus.$on( 'address-ready', () => {
						// if ( this.$refs.locationInput ) {
							// console.log( this.$refs )
							this.search = this.getSearch()
							this.$refs.locationInput.value = this.getSearch()
						// }
					} )
				} ) 
			} else {
				// Browser doesn't support Geolocation
				alert( 'The browser does not support geolocation.' )
			}
		},
		initializeFilters () {
			const params = parseURL( location )
			if ( !params ) {
				return
			}
			for ( const [ key, value ] of params ) {
				if ( key === 'brand' ) {
					// console.log( value )
					this.setActiveFilter( value )
					this.currentFilter = value
				}
				if ( key === 'pro' ) {
					this.setSubFilter( !!value )
					this.subFilter = !!value
				}
				if ( key === 'brandsegments' ) {
					// for checkboxes:
					// const values = value.split( ',' )
					// const segmentsArray = []
					// values.forEach( ( v ) => {
					// 	segmentsArray.push( v )
					// } )
					// for radio:
					const segmentsArray = []
					segmentsArray.push( value )
					// set array (both):
					this.setProductGroepen( segmentsArray )
					this.productGroepen = segmentsArray
				}
				if ( key === 'product' ) {
					this.setReferrerProduct( value )
				}
				if ( key === 'product_id' ) {
					this.setReferrerProductID( value )
				}
			}
		},
		// clearFilters () {
		// 	this.setActiveFilter( '' )
		// 	this.setSubFilter( false )
		// 	this.setProductGroepen( {} )
		// 	this.currentFilter = ''
		// 	this.subFilter = false
		// 	this.productGroepen = []
		// },
		clearSearch () {
			this.search = ''
			this.setSearchCoords( null )
			this.setSearch( '' )
			this.$refs.locationInput.value = ''
			eventbus.$emit( 'clear-search' )
		},
		createProDealersInfoLink ( proURL ) {
			return proURL ? `(<a href="${ proURL }">${ this.getMicroCopy().map_copy_search_label_pro_info }</a>)` : ``
		}
	},
	computed: {
		uniqueBrands () {
			let brands = []
			this.dealers.forEach( ( dealer ) => {
				dealer.brands.map( ( brand ) => {
					let existingBrandIndex = brands.findIndex( el => el.name === brand.name );

					// if the brand isn't in the array already: push it!
					if ( existingBrandIndex < 0 ) {
						existingBrandIndex = brands.push( {
							name: brand.name,
							slug: brand.slug,
							ID: brand.ID,
							productGroepen: [],
							infoPageUrl : brand.info_page_url
						} ) // returns the length of the new array
						existingBrandIndex--
					}

					// check if all of the productgroepen already exist, if not: add.
					if ( brand.productgroepen ) {
						let existingProductgroepen = brands[existingBrandIndex].productGroepen
						brand.productgroepen.forEach( ( productgroep ) => {
							const productgroupExists = existingProductgroepen.length > 0 ? existingProductgroepen.findIndex( el => el.ID === productgroep.ID ) : -1
							if ( productgroupExists < 0 ) {
								brands[existingBrandIndex].productGroepen.push( productgroep )
							}
						} )

					}
				} )
			} )

			const sortedBrands = brands.sort( ( a, b ) => {
				return a.name >= b.name ? 1 : -1
			} )
			this.setUniqueBrands( sortedBrands )
			return sortedBrands
		},
		filterValue () {
			return this.currentFilter
		},
		showSearch () {
			return this.getActiveFilter() !== ''
		}
		
	}
}
</script>